import { useEffect, useState } from 'react';
import {Row, Col, Button, Spin, Select, Space, Typography, Tabs, Table, Tag, Image, Modal} from 'antd';
import { ExportOutlined, FileAddOutlined, MenuOutlined } from "@ant-design/icons";
import {
  closestCenter,
  DndContext,
  DragOverlay,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  useSortable,
  verticalListSortingStrategy
} from "@dnd-kit/sortable";
import Header from "../../../components/HeaderList";
// import Products from './Products';
import Editor from './Editor';
import {ReactComponent as Edit} from '../../../assets/icons/edit.svg';
import {ReactComponent as Trash} from '../../../assets/icons/trash.svg';
import {getColumnSearchProps} from '../../../utils/tables';
import styles from '../styles/ProductsUI.module.css';
import classNames from 'classnames';


const { TabPane } = Tabs;
const {Option} = Select;
const { Text } = Typography;

const ProductsUI = props => {
  const {    
    loading,
    products,
    newProduct,
    product,
    handleProduct,
    confirmDelete,
    categories,
    brands,
    openEditor,
    closeEditor,
    editorVisible,
    reloadProds,
    deleteProdImage,
    exportData
  } = props;

  const [listprods, setListProds] = useState(products);
  const [typeKey, setTypeKey] = useState("1");
  
  const initialFetch = () => {
        const key = typeKey;
        if(key === "1") {
          setListProds(products);
        }
        if(key === "2") {
          setListProds(products.filter(x=>x.active===true));
        }
        if(key === "3") {
          setListProds(products.filter(x=>x.custom_stock.cantidad>0));
        }
        if(key === "4") {
          setListProds(products.filter(x=>x.custom_stock.cantidad==0));
        }
        if(key === "5") {
          setListProds(products.filter(x=>x.active===false));
        }
  };

  useEffect(() => {
    initialFetch();
  }, [loading, typeKey]);

  const getCategoryName = cat => {
    const index = categories.findIndex(el => el.id === cat);
    if (index > -1) {
      return categories[index].name;
    }
    return '-';
  };

  const getStockStyle = (config_stock) => {
    let r = <></>;
    if(config_stock.cantidad >= config_stock.umbralexistencia) {
      r = <Text type="success">En existencias ({config_stock.cantidad})</Text>;
    } else if(config_stock.cantidad == 0) {
      r = <Text type="danger">Agotado (0)</Text>;
    } else {
      r = <Text type="warning">Pocas unidades ({config_stock.cantidad})</Text>;
    }

    return r;
  };

  const getStockStyleRemote = (stock, config_stock) => {
    let r = <></>;
    if(stock >= config_stock.umbralexistencia) {
      r = <Text type="success">En existencias ({stock})</Text>;
    } else if(stock == 0) {
      r = <Text type="danger">Agotado (0)</Text>;
    } else {
      r = <Text type="warning">Pocas unidades ({stock})</Text>;
    }

    return r;
  };

  const getDescriptionBlock = (row) => {
    return <>
      <Text type='default'>{row.name}</Text><br />
      <small>Tamano:{row.custom_data.medida} Potencia: {row.custom_data.potencia} Impedancia: {row.custom_data.impedancia}</small>
    </>

  };

  const filterData = (key, event) => {
    console.log(key);
    console.log(event);

    setTypeKey(key);
  };

  const columns = [
    {
      key: "dragHandle",
      dataIndex: "id",
      title: "Drag",
      width: 30,
      render: () => <MenuOutlined style={{ cursor: "grab", color: "#999" }} />
    },
    {
      title: 'Orden',
      key: 'position',
      dataIndex: 'position',
      sorter: (a, b) => a.position - b.position,
    },
    {
      title: 'SKU',
      key: 'id',
      dataIndex: 'id',
      ...getColumnSearchProps('custom_stock.sku'),
      render: (val, record) => record.custom_stock.sku
    },
    {
      title: '',
      key: 'image',
      dataIndex: 'image',
      render: (val, record) => (
        <Image alt='Imagen del Producto' width={50} height={50} src={record.image}
          fallback="data:image/png;base64,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"
        />
      ),
    },
    {
      title: 'Descripción',
      key: 'name',
      dataIndex: 'name',
      ...getColumnSearchProps('name'),
      render: (val, record) => getDescriptionBlock(record),
    },
    {
      title: 'Inventario',
      key: 'custom_stock.cantidad',
      dataIndex: 'custom_stock.cantidad',
      align: 'center',
      render: (val, record) => getStockStyleRemote(record.existencia, record.custom_stock),
    },
    {
      title: 'Precio',
      key: 'price',
      dataIndex: 'price',
      render: (val, record) => (
        <>{record.currency} {record.price.toFixed(2)}</>
      )
    },
    {
      title: 'Categoría',
      key: 'category',
      dataIndex: 'category',
      filters: categories.map(cat => ({
        text: cat.name,
        value: cat.id,
      })),
      onFilter: (val, record) => record.categoryId === val,
      render: (val, record) => getCategoryName(record.categoryId),
    },
    
    {
      title: 'Editar',
      align: 'center',
      key: 'idEdit',
      dataIndex: 'id',
      render: (id, record) => (
        <div className={styles.actions}>
          <div className={styles.edit} onClick={() => openEditor(record)}>
            <Edit />
          </div>
          <div className={styles.divider} />
          <div className={styles.delete} onClick={() => confirmDelete(id)}>
            <Trash />
          </div>
        </div>
      ),
    },
  ];

  /*** Agregando parte para mover dinamicamente */
  const [dataSource, setDataSource] = useState(listprods);
  const [activeId, setActiveId] = useState(null);

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates
    })
  );

  function handleDragStart(event) {
    const { active } = event;
    setActiveId(active.id);
  }

  function handleDragEnd(event) {
    const { active, over } = event;
    if (active.id !== over.id) {
      setListProds((items) => {
        // In this example, find an item, where `item.key` === `useSortable.id`.
        const oldIndex = items.findIndex((item) => item.id === active.id);
        const newIndex = items.findIndex((item) => item.id === over.id);
        return arrayMove(items, oldIndex, newIndex);
      });
    }
    // Stop overlay.
    setActiveId(null);
  }

  
  function DraggableWrapper(props) {
    const { children, ...restProps } = props;
    /**
     * 'children[1]` is `dataSource`
     * Check if `children[1]` is an array
     * because antd gives 'No Data' element when `dataSource` is an empty array
     */
    return (
      <SortableContext
        items={
          children[1] instanceof Array
            ? children[1].map((child) => child.id)
            : []
        }
        strategy={verticalListSortingStrategy}
        {...restProps}
      >
        <tbody {...restProps}>
          {
            // This invokes `Table.components.body.row` for each element of `children`.
            children
          }
        </tbody>
      </SortableContext>
    );
  }

  function DraggableRow(props) {
    const {
      attributes,
      listeners,
      setNodeRef,
      isDragging,
      overIndex,
      index
    } = useSortable({
      id: props["data-row-key"]
    });
    const isOver = overIndex === index;
    const { children, ...restProps } = props;
    const isData = children instanceof Array;
    const style = {
      ...restProps?.style,
      ...(isData && isDragging ? { background: "#80808038" } : {}),
      ...(isData && isOver ? { borderTop: "5px solid #ec161638" } : {})
    };
    /**
     * 'children[1]` is a row of `dataSource`
     * Check if `children[1]` is an array
     * because antd gives 'No Data' element when `dataSource` is an empty array
     */
    return (
      <tr ref={setNodeRef} key={index} {...attributes} {...restProps} style={style}>
        {children instanceof Array
          ? children.map((child) => {
              const { children, key, ...restProps } = child;
              return key === "dragHandle" ? (
                <td {...listeners} {...restProps}>
                  {child}
                </td>
              ) : (
                <td {...restProps}>{child}</td>
              );
            })
          : children}
      </tr>
    );
  }

  return (
    <div className={styles.view}>
      <Header
        back="/"
        title="Productos"
        actions={
          <Space>
            <Button size="large" icon={<ExportOutlined />} type="primary" onClick={exportData}>EXPORTAR</Button>
            <Button size="large" icon={<FileAddOutlined />} type="secondary" onClick={newProduct}>NUEVO PRODUCTO</Button>
          </Space>
        }
      />
      {loading ? (
        <div className={styles.loader}>
          <Spin size="large" />
        </div>
      ) : (
        <div>
          <Row style={{ marginTop: "20px" }}>
            <Col lg={24}>
              <div className="tabs">
                <Tabs defaultActiveKey="1" onTabClick={filterData}>
                  <TabPane tab={`Todos (${products.length})`} key="1" ></TabPane>
                  <TabPane tab={`Publicados (${products.filter(x=>x.active==true).length})`} key="2"></TabPane>
                  <TabPane tab={`En Existencia (${products.filter(x=>x.custom_stock.cantidad>0).length})`} key="3"></TabPane>
                  <TabPane tab={`Agotados (${products.filter(x=>x.custom_stock.cantidad==0).length})`} key="4"></TabPane>
                  <TabPane tab={`Borrador (${products.filter(x=>x.active==false).length})`} key="5"></TabPane>
                </Tabs>
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "20px" }}>
            <Col lg={24}>
                <Table
                  columns={columns}
                  dataSource={listprods}
                />
            </Col>
          </Row>
        </div>
      )}
      
      <Modal
        destroyOnClose
        closable={false}
        maskClosable={false}
        visible={editorVisible}
        footer={false}
        onCancel={closeEditor}
        width={1100}
      >
        <Editor
          close={closeEditor}
          product={product}
          brands={brands}
          categories={categories}
          handleProduct={handleProduct}
          products={products}
          deleteProdImage={deleteProdImage}
          reloadProds={reloadProds}
        />
      </Modal>
    </div>
  );
};

export default ProductsUI;
